import guardAPI from '@/api/sorority-wars/guardAPI'

const state = {
  skins: [],
  parts: []
}

const mutations = {
  setSkins (state, skins) {
    state.skins = skins
  },
  setParts (state, parts) {
    state.parts = parts
  },
  setPartsAndSkins (state, { parts, skins }) {
    state.skins = skins
    state.parts = parts
  },
  setPartActive (state, { part, item }) {
    state.parts = state.parts.map(localPart => {
      if (localPart.id === part || localPart.name === part) {
        localPart.active = item
      }
      return localPart
    })
  },
  setClearAll (state) {
    state.parts = state.parts.map(localPart => {
      localPart.active = null
      return localPart
    })
  },
  clearSingle (state, part) {
    state.parts = state.parts.map(localPart => {
      if (localPart.id === part || localPart.name === part) {
        localPart.active = null
      }
      return localPart
    })
  }
}

const actions = {
  getSkins (context) {
    guardAPI.showSkins().then(res => {
      context.commit('setSkins', res.data.sorority.skins)
      context.commit('setParts', res.data.sorority.parts)
    })
  },
  equip (context, { item, part }) {
    if (part === 'body' || part === 0) {
      return guardAPI.changeBody(item)
        .then(r => {
          if (r.data.success) {
            context.commit('setPartActive', { part, item })
            context.commit('updateAvatarTimer', null, { root: true })
          }
          return r.data
        })
    } else {
      return guardAPI.equip(item)
        .then(r => {
          if (r.data.success) {
            context.commit('setPartActive', { part, item })
            context.commit('updateAvatarTimer', null, { root: true })
            context.dispatch('getSkins').then()
          }
          return r.data
        })
    }
  },
  clearAll (context) {
    return guardAPI.clearAll()
      .then(r => {
        context.commit('setClearAll')
        context.commit('updateAvatarTimer', null, { root: true })
        context.dispatch('getSkins').then()
        return r.data
      })
  },
  clearPart (context, part) {
    return guardAPI.clearSingle(part)
      .then(r => {
        context.commit('clearSingle', part)
        context.commit('updateAvatarTimer', null, { root: true })
        context.dispatch('getSkins').then()
        return r.data
      })
  }
}

const getters = {
  skins: (state, getters) => {
    const active = getters.actives.body
    return state.skins.map(item => {
      item.active = item.id === active
      return item
    })
  },
  actives: state => {
    return state.parts.reduce((obj, item) => {
      obj[item.id] = item.active
      obj[item.name] = item.active
      return obj
    }, { body: 0 })
  },
  nameToId: state => name => {
    return (state.parts.find(item => item.name === name) || { id: 0 }).id
  }
}

export default { state, mutations, actions, getters, namespaced: true }
